import styled from 'styled-components';

export const Field = styled.textarea`
  background-color: #f3f7f9;
  border: 1px solid #e4eaec;
  padding: 9px 15px;
  font-size: 14px;
  border-radius: 10px;
  color: #768390;
  width: 100%;
  min-height: 88px

  &::placeholder {
    color: #a7b3ba;
  }
`;



// WEBPACK FOOTER //
// ./src/components/TextArea/styles.js